







/* Created- 22 - Mar - 2019 */

import { Component, Vue, Prop } from "vue-property-decorator";
import EventBus from "../../../Plugins/eventbus";
import { ParticaEvent } from "../../../Models/ParticaEvent";


@Component(
	{
		name: "ParticaSnackbar"
	})
export default class ParticaSnackbar extends Vue {
	private snackbar: boolean = false;
	private y: string = "top";
	private timeout: number = 10000;
	private text: string = "Welcome to Partica.";

	private created() {
		EventBus.$on("snackbar-event", async (data: any) =>
			this.handleEvent(data as ParticaEvent)
		);
	}

	private handleEvent(event: ParticaEvent) {
		this.text = event.item;
		this.snackbar = true;
	}
}
